export default { title: 'Google-Bewertung hochladen' };
